module.exports = __webpack_public_path__ + "static/media/audio.07e90cb2.svg";